import React, { useState } from "react";
import { jsPDF } from "jspdf";
import "./style.css";
import leftArrowIcon from "../../../Assets/Icons/left-arrow.svg";
import downloadIcon from "../../../Assets/Icons/download-icon.svg";
import editIcon from "../../../Assets/Icons/edit-icon.svg";
import cancelIcon from "../../../Assets/Icons/iconclose-grey.png";
import ReactQuill from "react-quill";

import "react-quill/dist/quill.snow.css";
import { updateCaseSummary } from "../../../Services";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import Button from "../Buttons/Button";
import { usePatientContext } from "../../../Context/PatientContext";

const CaseSummary = (props) => {
  const { handleScreenSwitch } = props;
  const { patientDetails } = usePatientContext();
  const [editMode, setEditMode] = useState(false);
  const [content, setContent] = useState(patientDetails.caseSummary);
  const { patientId } = useParams(); /* Read dynamic URL params */
  const { physician } = useAuth();

  const handleEditModeSwitch = () => {
    setEditMode((prev) => !prev);
    setContent(patientDetails.caseSummary);
  };

  /**
   * Function to download pdf file
   * @param data
   */
  const downloadPDF = (data) => {
    // console.log(data, typeof data, "data");
    let el = document.createElement("div");
    el.style.width = "400px";
    el.style.fontSize = "10px";
    // el.style.display = "block";
    el.style.padding = "30px";
    el.innerHTML = data;
    const margins = {
      top: 40,
      bottom: 60,
      left: 40,
      width: 522,
    };

    // const margin = { top: 10, right: 20, bottom: 10, left: 20 };
    var options = {
      margin: [10, 20, 10, 20],
      callback: function (pdf) {
        pdf.save("summary.pdf");
        // pdf.save(fileName ? fileName : uuid() + ".pdf");
        el.remove();
      },
    };

    const pdf = new jsPDF("p", "px", "letter");
    pdf.html(el, options);
    // const doc = new jsPDF();

    // doc.html(data, 10, 10);
    // doc.save("summary.pdf");

    // const csvData = convertToCSV(data);
    // const pdfData = "data:text/csv;charset=utf-8," + encodeURIComponent(data);
    // console.log(pdfData);

    // const link = document.createElement("a");
    // link.href = pdfData;
    // link.download = "summary.pdf";
    // link.click();
  };

  //List of buttons
  const btnsList = [
    {
      _id: 13,
      btnName: "Back",
      btnIcon: leftArrowIcon,
      btnFunction: handleScreenSwitch,
    },
    {
      _id: 14,
      btnName: "Download",
      btnIcon: downloadIcon,
      btnFunction: downloadPDF,
    },
    {
      _id: 15,
      btnName: editMode ? "Cancel" : "Edit",
      btnIcon: editMode ? cancelIcon : editIcon,
      btnFunction: handleEditModeSwitch,
    },
  ];

  /**
   * Function to set value in the text area of notes
   * @param value - string
   */
  const handleChange = (value) => {
    if (editMode) {
      setContent(value);
    }
  };

  // Event handler for saving case summary
  const handleCaseSummary = async (event) => {
    try {
      const summaryResponse = await updateCaseSummary(
        physician.physician._id,
        patientId,
        content
      );
      // console.log(summaryResponse, "summary response");

      if (!summaryResponse.error) {
        setContent(summaryResponse.data.caseSummary);
        setEditMode(false);
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  return (
    <div className="case-summary" id="case-summary">
      {/* Heading and Buttons Container */}
      <div className="case-summary-header">
        <h5 className="h5-400 dark-grey">Case Summary</h5>
        <div className="case-summary-buttons-container">
          {btnsList.map((btn) => (
            <button
              key={btn._id}
              className="case-summary-buttons"
              onClick={
                btn.btnName === "Download"
                  ? () => btn.btnFunction(content)
                  : btn.btnFunction
                // btn.btnFunction
              }
            >
              <img
                className="case-summary-btn-icon"
                src={btn.btnIcon}
                alt="button-icon"
              />{" "}
              {btn.btnName}
            </button>
          ))}
          {editMode && <Button btnType="save" onClick={handleCaseSummary} />}
        </div>
      </div>

      {/* case summary text-area */}
      <div className="case-summary-text-area-container">
        {/* edit mode */}
        {editMode && (
          // typeof window !== "undefined" && (
          // Only render the editor on the client side
          <ReactQuill
            theme="snow"
            defaultValue={content}
            value={content}
            onChange={handleChange}
            placeholder="Type here..."
            className="quill-editor-container"
          />
        )}
        {/* view mode */}
        {!editMode && (
          <ReactQuill
            theme="bubble"
            value={content}
            readOnly={true}
            className="quill-editor-container"
          />
        )}
      </div>
    </div>
  );
};

export default CaseSummary;
